var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabReports = function SvgTabReports(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4575",
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -288.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5995",
    fill: "currentColor",
    fillOpacity: 0.502,
    fillRule: "evenodd",
    d: "M.796 290.65H7.67l-1.028-1.11-1.251-.597-1.801-.093-1.497.596z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5924",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.529,
    d: "M3.175 289.08v7.568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5926",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.529,
    d: "M.265 292.77h8.07"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path5920",
    cx: 4.233,
    cy: 292.77,
    r: 3.969,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.529
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5928",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.529,
    d: "M1.008 295.15h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5149",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.397,
    d: "m1.182 291.58.395.38.791-.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5955",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.397,
    d: "m1.182 293.89.395.38.791-.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5999",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.529,
    d: "M1.008 290.39h6.36"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabReports);
export default ForwardRef;